import styled from 'styled-components';
import colors from '../../../config/colors';

const Heading = styled.div`
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 769px) {
    display: block;
  }

  h1, h2, h3, h4, h5, h6 {
    margin-bottom: 0;
    font-weight: 500;
    font-family: 'Gilroy-Medium';

    @media (max-width: 769px) {
      margin-bottom: 14px;
    }
  }

  h3 {
    font-family: 'Gilroy-Bold';
    font-size: 32px;
  }

  a {
    font-family: "Gilroy-Medium";
  }

  ul {
    padding: 10px 15px;
    margin-bottom: 0;
    list-style: none;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    background: ${colors.GRAY_EXTRA_LIGHT};
    border-radius: 3px;
    flex-shrink: 0;
    justify-content: space-between;

    .select-wrapper {
      margin: 0;

      svg {
        stroke: ${colors.BLACK};
      }
    }

    select {
      margin-left: 20px;
      background: ${colors.WHITE};
    }

    @media (max-width: 500px) {
      justify-content: center;
      select {
        margin: 0 10px;
      }
      li {
        margin: 10px 0;
      }
    }
  }
`;

const FormHeading = styled.div`
  margin: 20px 0;
  font-size: 20px;
  line-height: 30px;
  font-family: "Gilroy-Bold";
`;

export {
  Heading,
  FormHeading
};
